import { i18n } from "discourse-i18n";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
import templateOnly from "@ember/component/template-only";
const FilterForMore = setComponentTemplate(precompileTemplate("\n  {{#if @collection.content.shouldShowMoreTip}}\n    <div class=\"filter-for-more\">\n      {{i18n \"select_kit.components.filter_for_more\"}}\n    </div>\n  {{/if}}\n", {
  strictMode: true,
  scope: () => ({
    i18n
  })
}), templateOnly(undefined, "filter-for-more:FilterForMore"));
export default FilterForMore;